export const uploadFileModal = {
  title: 'Dokument hochladen',
  buttonText: 'Hochladen',
  errorToastText: 'Datei konnte nicht hochgeladen werden.',
  fileInputLabel: 'Bitte laden Sie eine Datei hoch',
  description: 'Bitte wählen sie ein Dokument aus, welches sie hochladen möchten.',
  titlePlaceholder: 'Name',
  notePlaceholder: 'Notiz',
}
